import * as React from "react";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { TooltipText } from "../tooltip";
import { convertLeagueIdToReplacements } from "./IdLeaguePlacement";
export var LeagueRewardButtonWrapper = React.memo(function (_a) {
    var requiredLeague = _a.requiredLeague, disabled = _a.disabled, children = _a.children;
    if (!disabled) {
        return React.createElement("div", null, children);
    }
    var replacements = convertLeagueIdToReplacements(requiredLeague);
    return (React.createElement(TooltipText, { id: IdLoca.tooltip_leagueReward_locked, replacements: replacements }, children));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/LeagueRewardButtonWrapper.tsx
// module id = 967
// module chunks = 3